import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  MenuItem,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { get, postJsonData } from "../network/ApiController";
import Loader from "../component/loading-screen/Loader";
import { whiteColor } from "../theme/setThemeColor";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";

const AddUserService = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState(""); // ✅ IMPORTANT

  // 🔹 GET USERS
  const getUsers = () => {
    get(
      ApiEndpoints.GET_USERS,
      `page=1&paginate=10&role=Api&export=`,
      setRequest,
      (res) => {
        const usersArray = res?.data?.data || [];
        setUsers(
          usersArray.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        );
      },
      (error) => apiErrorToast(error)
    );
  };

  const handleOpen = () => {
    setOpen(true);
    getUsers();
  };

  const handleClose = () => {
    setOpen(false);
    setUserId(""); // reset
  };

  // 🔹 SUBMIT ADD USER KEY
  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    const data = {
      user_id: userId, // ✅ NOW SENT PROPERLY
    };

    postJsonData(
      ApiEndpoints.CREATE_USER_SERVICES,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res?.message);
        if (refresh) refresh();
        handleClose();
      },
      (err) => apiErrorToast(err)
    );
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Tooltip title="Add User Service">
        <Button
          variant="outlined"
          className="refresh-icon-risk"
          onClick={handleOpen}
          startIcon={
            <IconButton sx={{ p: 0, color: whiteColor() }}>
              <AddCircleOutlineIcon />
            </IconButton>
          }
          sx={{ py: 0.3 }}
        >
          User Service
        </Button>
      </Tooltip>

      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400 }} className="sm_modal">
          <Loader loading={request} />
          <ModalHeader title="Add User Service" handleClose={handleClose} />

          <Box
            component="form"
            id="addUserServiceForm"
            onSubmit={handleSubmit}
            sx={{ "& .MuiTextField-root": { m: 2 } }}
          >
            <Grid container>
              {/* USER DROPDOWN */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="User"
                    select
                    size="small"
                    required
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                  >
                    {users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.name} ({user.id})
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mr: 2 }}>
            <ModalFooter
              form="addUserServiceForm"
              type="submit"
              btn="Submit"
              disable={request}
            />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AddUserService;
